<template>
    <div class="kv-filter-container kv-filter-period">
        <span class="kv-filter-label">{{
            label
            }}
        </span>
        <KvDateRangePicker ref="picker" v-model="dateRange" :all-period="{ start: placeCreatedDate, end: new Date() }" :max-range-months="options.maxRangeMonths">
            <template #trigger="{ toggle, range }">
                <div class="kv-filter-input" @click="toggle">
                    <Icon icon-class="ui-calendar" size="2" />
                    <div  class="period-date">{{ range }}</div>
                    <span
                        class="kv-remove-filter"
                        v-if="removable"
                        @click.stop.prevent="$emit('remove')"
                    >
                        <Icon icon-class="ui-x-close" size="2" />
                    </span>
                </div>
            </template>

        </KvDateRangePicker>

    </div>
</template>
<style lang="less">
.kv-filter-period {
    display: inline-flex;
    flex-direction: column;
}

.kv-remove-filter {
    cursor: pointer;
    display: flex;
}

i.glyphicon.glyphicon-calendar.fa.fa-calendar {
    display: none;
}
</style>linked-calendars
<script>
import DateRangePicker from "vue2-daterange-picker";
import keviApi from "../../../keviApi";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import Icon from "../../icon/icon";
import KvButton from "../../form/kv-button.vue";
import KvDateRangePicker from "@/components/inputs/kv-date-range-picker.vue";
import { placeStartOfDayISO, placeEndOfDayISO, isoToPlaceLocalDate } from "../../../helpers/datetime";

export default {
    name: "kv-filter-period",
    components: {
        KvDateRangePicker
    },
    props: {
        name: {
            type: String,
            default: "",
        },
        currentValue: {
            type: [Object, String, Number],
            default: null,
        },
        label: {
            type: String,
            default: "",
        },
        removable: Boolean,
        options: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            focus: false,
            valueType: "timeDiff",
            value: null,
            today: new Date(),
            dateRange: {
                start: new Date(),
                end: new Date(),
            },
            placeCreatedDate: null,
        };
    },
    components: {
        DateRangePicker,
        KvButton
    },
    mounted() {
        const tz =
            (this.$store.state.place && this.$store.state.place.timezone) ||
            undefined;
        let start = null;
        let end = null;
        if (this.currentValue === null) {
            start = new Date();
            start.setDate(start.getDate() - 30);
            end = new Date();
        } else {
            // Stored values are place-tz day-boundary instants; map them back to
            // the place-local calendar day so the picker (which works in
            // browser-local days) doesn't drift across refreshes.
            start = this.currentValue.start ? isoToPlaceLocalDate(this.currentValue.start, tz) : null;
            end = this.currentValue.end ? isoToPlaceLocalDate(this.currentValue.end, tz) : null;
        }
        if (start && end) {
            this.dateRange.start = start;
            this.dateRange.end = end;
        }
        this.changed();

        this.updatePlaceCreatedDate();
    },
    methods: {
        setRange(data) {
            const picker = this.$refs.picker;
            picker.start = data[0];
            picker.end = data[1];
            picker.in_selection = false;
        },
        updatePlaceCreatedDate() {
            let options = keviApi.getOptions(
                "place/" + this.$store.state.place.id + "/details",
                "GET",
            );
            this.$http(options).then((response) => {
                this.placeCreatedDate = response.body.oldest_order || response.body.created_at;
            });
        },
        getValue() {
            // Emit the selected calendar days as start/end of day in the
            // place timezone (as proper ISO instants), so reports filter on
            // the seller's local calendar rather than the browser's or UTC.
            const tz =
                (this.$store.state.place && this.$store.state.place.timezone) ||
                undefined;
            return {
                start: placeStartOfDayISO(this.dateRange.start, tz),
                end: placeEndOfDayISO(this.dateRange.end, tz),
            };
        },
        changed() {
            this.$emit("changed", this.getValue());
        },
    },
    computed: {
        placeId() {
            return this.$store.state.place.id;
        },
    },
    watch: {
        placeId() {
            this.updatePlaceCreatedDate();
            this.loadData();
        },
        dateRange() {
            this.changed();
        },
        focus() {
            setTimeout(() => {
                const picker = this.$refs.picker;
                if (picker){
                   picker.toggleShow(); 
                }
            }, 100);
        }
    },
};
</script>
